import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { ErrorsService } from './errors.service';
import {
  CreateLoanPortfoliosByPartnersRequest,
  LoanPreSaleSearchQuery, LoanSaleDataAmountsRequest, LoanSaleDataAmountsResponse, LoanSaleDataPreSellRequest,
  LoanSaleDataResponseSearchResult,
  LoanSaleSearchQuery
} from '@backoffice-monorepo/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoanSaleDataService extends BaseService {

  constructor(
    protected http: HttpClient,
    protected errorsService: ErrorsService
  ) {
    super(http, errorsService);
  }

  list(searchQuery: LoanSaleSearchQuery): Observable<LoanSaleDataResponseSearchResult> {
    return this.post(`/api/loan-sale/data/search`, searchQuery);
  }

  setPreSellStatus(request: LoanSaleDataPreSellRequest): Observable<unknown> {
    return this.post(`/api/loan-sale/data/pre-sell`, request);
  }

  preSell(loanIds: number[]): Observable<unknown> {
    return this.post(`/api/loan-sale/portfolio`, {loanIds});
  }

  generatePreviewPreSellReport(request: LoanSaleDataPreSellRequest): Observable<Blob> {
    return this.post(`/api/loan-sale/data/preview-pre-sell-report`, request, {'responseType': 'blob'});
  }

  calculateTotalAndAverageAmounts(request: LoanSaleDataAmountsRequest): Observable<LoanSaleDataAmountsResponse> {
    return this.post(`/api/loan-sale/data/calculate-amounts`, request);
  }

  createPortfoliosByPartners(request: CreateLoanPortfoliosByPartnersRequest): Observable<unknown> {
    return this.post(`/api/loan-sale/portfolios/by-partners`, request);
  }

  addLoansToLoanSaleData(file: File, shouldMarkAsPreSold = false): Observable<void> {
    const formData = new FormData();
    formData.append(
      'request',
      new Blob(
        [],
        {type: "application/json"}
      )
    );
    formData.append('file', file);
    return this.post(`/api/loan-sale/data/import?shouldMarkAsPreSold=${shouldMarkAsPreSold}`, formData);
  }
}
